import { Table } from "@mui/material";
import { styled } from "@mui/material/styles";
const CustomTable = styled(Table)(({ theme }) => ({
  // border: "1px solid red",
  "& .MuiTableContainer-root": {
    borderRadius: 0,
  },
  "& .MuiTableCell-head": {
    backgroundColor: "#edf4fb",
    height: "105px",
    maxHeight: "105px",
  },
  "& .MuiTableRow-head": {
    border: "1px solid #d5d5d5",
    backgroundColor: "#edf4fb",
    height: "105px",
    maxHeight: "105px",
  },
  "& TableCell": {
    border: "1px solid #d5d5d5",
  },
  // tableLayout: "fixed",
  maxWidth: "100%",
  width: "100%",
  position: "sticky",
  top: 0,
  zIndex: 1,
}));

export default CustomTable;
